import { existingPaymentSystems } from "../constants/existingPaymentSystems";
import { bankLogos } from "../containers/SeasonPass/constants";

export const getVisibleBankLogos = (eventData) => {
    if (eventData) {
      const availablePaymentSystems = eventData.allowedPaymentProviders.map(pp => {
        return pp.name
      });

      const notUsedPaymentLogos = existingPaymentSystems.filter(paySystem => {
        return !availablePaymentSystems.some(ps => ps === paySystem);
      })

      return bankLogos.filter(bl => {
        return !notUsedPaymentLogos.some(logo => logo === bl.alt)
      });
    }

    return [];
  };
